import { useIsUngatedFor } from 'calling-orchestration-shared-library/hub-info/hooks/useIsUngatedFor';
import { gate } from 'hub-http/gates';
const NEW_MEDIA_ELEMENT_FEATURE = gate('ChannelManagerExpFE:GenericMediaElement');
export const useIsUngatedForNewMediaElement = () => !useIsUngatedFor(NEW_MEDIA_ELEMENT_FEATURE);